// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BuyerDealsComponent } from './buyer-deals/buyer-deals.component';

const routes: Routes = [
    {
        path: '',
        component: BuyerDealsComponent,
    },
    {
        path: ':dealId',
        loadChildren: () => import('../buyer-deal-container/buyer-deal-routing.module').then((m) => m.BuyerDealRoutingModule),
        data: {
            title: 'My Vehicle',
        },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class BuyerDealsRoutingModule {}
